import styled from 'styled-components';
import * as Styles from '../../utils/styleUtils';

export const CalendarWrapper = styled.div`
  && {
    ${Styles.BorderStyles}
    color: #333;
    font-family: 'sans-serif';
    font-size: 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
`;

export const CalendarHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px;
  background-color: #E3E3E3;
  font-weight: normal;
  flex-shrink: 0;
  border-bottom: 1px solid ${({ styleProps }) => styleProps?.color || '#333'};
`;

export const MonthYearSelectorWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  flex-grow: 1;
  margin: 0 5px;
`;

export const HeaderDropdown = styled.div`
  border: 1px solid #ccc;
  padding: 0 6px;
  background-color: #fff;
  border-radius: 3px;
  position: relative;
  padding-right: 18px;
  flex-grow: 1;
  text-align: center;
  color: #333;

  &::after {
    content: '';
    display: inline-block;
    width: 5px;
    height: 5px;
    border-right: 1px solid #333;
    border-bottom: 1px solid #333;
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-60%) rotate(45deg);
  }
`;

const HeaderArrow = styled.span`
  cursor: pointer;
  display: inline-block;
  width: 16px;
  height: 16px;
  text-indent: -9999px; /* Hide the text */
  background-repeat: no-repeat;
`;

export const PrevArrow = styled(HeaderArrow)`
  background-position: -80px -192px;
`;

export const NextArrow = styled(HeaderArrow)`
  background-position: -48px -192px;
`;

export const CalendarGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
  margin-top: 5px;
  text-align: center;
  flex-grow: 1;
  grid-auto-rows: 1fr;
`;

export const Day = styled.div`
  background-color: ${({ isSelected }) => (isSelected ? '#f89b3c' : 'transparent')};
  border-radius: 2px;
  font-weight: ${({ isHeader }) => (isHeader ? 'bold' : 'normal')};
  color: ${({ styleProps }) => styleProps?.color || '#333'};
  display: flex;
  align-items: center;
  justify-content: center;
`;